
<template>
    <control-wrapper v-bind="controlWrapper" :styles="styles" :isFocused="isFocused" :appliedOptions="appliedOptions">
         <v-label :class="styles.label.root"
    v-bind="vuetifyProps('v-label')">{{computedLabel}}</v-label>
         
        <el-link v-for="item in control.data" :key="item.path"  type="primary" @click="btnClick(item)">{{item.text}}</el-link>
    
    </control-wrapper>
</template>

<script>
import { formatIs, rankWith, } from '@jsonforms/core';

import { rendererProps, useJsonFormsControl } from '@jsonforms/vue2';
import { useVuetifyControl, ControlWrapper } from '@jsonforms/vue2-vuetify';
import { defineComponent, ref } from 'vue';

const controlRenderer = defineComponent({
    name: 'attachment',
    components: {
        ControlWrapper
    },
    props: {
        ...rendererProps(),
    },
   
    setup(props) {
        const loading = ref(false);
        const items = ref([]);
        const search = ref('');
        const timeout = ref(null);
        const control = useVuetifyControl(useJsonFormsControl(props), (value) => value || undefined);
        return { ...control, loading, items, search, timeout }
    },
    mounted() {
       
    },
    methods: { 
        btnClick(item){
            window.open(item.url)
        }   
    },
    
    watch: {
    },
})

export default controlRenderer;
export const entry = {
    renderer: controlRenderer,
    tester: rankWith(10, formatIs("zysl-attachment")),
};
</script>
<style lang="less" scoped>

</style>